<div class="inputContainer" (click)="focusInput()">
  @for (item of codeLengthArray; track item; let i = $index) {
    <div
      class="inputBox"
      [class.light]="light"
    [ngClass]="{
      active: isFocussed && codeControl.value?.length === i,
      complete: codeControl.value?.length === 6
    }"
    ></div>
  }
  <input
    name="Verification Code"
    #code
    (blur)="isFocussed = false"
    (focus)="isFocussed = true"
    type="text"
    autocomplete="one-time-code"
    (keypress)="numericOnly($event)"
    [formControl]="codeControl"
    autofocus
    [maxlength]="codeLength"
    [ngClass]="{ noCaret: codeControl.value?.length === 6 }"
    />
</div>
